// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 991px) {
  .socialcontainerPlain button {
    width: 58px;
    height: 58px;
    margin: 6px;
  }
}
@media screen and (min-width: 992px) {
  .socialcontainerPlain button {
    width: 58px;
    height: 58px;
    margin: 6px;
  }
}

/* .socialcontainerPlain {
  margin-top: 24px;
} */
.socialcontainerPlain button {
  text-align: center;
  border: 2px solid #ddd;
  border-radius: 50%;
  mask-border-outset: 1px;
  background: white;
  color: #000;
}
.socialcontainerPlain button:hover {
  border: none;
  background-color: #255a61;
  color: white;
}

.socialcontainerV1 {
  margin-top: 18px;
}
.socialcontainerV1 button {
  width: 42px;
  height: 42px;
  margin-top: 4px;
  text-align: center;
  border-radius: 50%;
  mask-border-outset: 1px;
  background: #e5fbfe;
  color: #555;
}
.socialcontainerV1 button:hover {
  border: none;
  background-color: #255a61;
  color: white;
}

#btnLinkedin:hover {
  background-color: #2a66ba;
}
#btnGithub:hover {
  background-color: black;
}
#btnLeetcode:hover {
  background-color: black;
  color: #e59d3e;
}
#btnGoogle:hover {
  background-color: red;
}
#btnInstagram:hover {
  background: linear-gradient(
    to bottom right,
    blue,
    purple,
    red,
    orange,
    yellow
  );
}
#btnTwitter:hover {
  background-color: #2a66ba;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SocialBar/socialBar.css"],"names":[],"mappings":"AAAA;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;;GAEG;AACH;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["@media screen and (max-width: 991px) {\n  .socialcontainerPlain button {\n    width: 58px;\n    height: 58px;\n    margin: 6px;\n  }\n}\n@media screen and (min-width: 992px) {\n  .socialcontainerPlain button {\n    width: 58px;\n    height: 58px;\n    margin: 6px;\n  }\n}\n\n/* .socialcontainerPlain {\n  margin-top: 24px;\n} */\n.socialcontainerPlain button {\n  text-align: center;\n  border: 2px solid #ddd;\n  border-radius: 50%;\n  mask-border-outset: 1px;\n  background: white;\n  color: #000;\n}\n.socialcontainerPlain button:hover {\n  border: none;\n  background-color: #255a61;\n  color: white;\n}\n\n.socialcontainerV1 {\n  margin-top: 18px;\n}\n.socialcontainerV1 button {\n  width: 42px;\n  height: 42px;\n  margin-top: 4px;\n  text-align: center;\n  border-radius: 50%;\n  mask-border-outset: 1px;\n  background: #e5fbfe;\n  color: #555;\n}\n.socialcontainerV1 button:hover {\n  border: none;\n  background-color: #255a61;\n  color: white;\n}\n\n#btnLinkedin:hover {\n  background-color: #2a66ba;\n}\n#btnGithub:hover {\n  background-color: black;\n}\n#btnLeetcode:hover {\n  background-color: black;\n  color: #e59d3e;\n}\n#btnGoogle:hover {\n  background-color: red;\n}\n#btnInstagram:hover {\n  background: linear-gradient(\n    to bottom right,\n    blue,\n    purple,\n    red,\n    orange,\n    yellow\n  );\n}\n#btnTwitter:hover {\n  background-color: #2a66ba;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
